import { OfferUpdateInput } from '@occc/graphql';

import { Operation } from '../types';

export const makeOfferUpdateOperation = (
  offerId: string,
  values: Omit<OfferUpdateInput, 'id'>,
): Operation => {
  const input: OfferUpdateInput = {
    id: offerId,
    ...values,
  };
  return {
    name: 'offerUpdate',
    variables: { input },
  };
};
